import { VideoUrl } from '../types/banner/video-url';

export const isVideoUrlField = (value: any): value is VideoUrl => {
  return typeof value === 'object' && value !== null && 'originalUrl' in value;
};

// Función genérica que recorre VideoUrls y permite aplicar lógica personalizada
export const processVideoUrls = <T>(config: Record<string, any>, processor: (videoUrl: any) => T | null): T[] => {
  const results: T[] = [];

  Object.values(config).forEach(fieldValue => {
    // VideoUrl individual
    if (isVideoUrlField(fieldValue)) {
      const result = processor(fieldValue);
      if (result !== null) results.push(result);
    }

    // Array de VideoUrl
    else if (Array.isArray(fieldValue)) {
      fieldValue.forEach(item => {
        if (isVideoUrlField(item)) {
          const result = processor(item);
          if (result !== null) results.push(result);
        }
      });
    }
  });

  return results;
};

export const hasVideoUrlField = (config: Record<string, any>): boolean => {
  return processVideoUrls(config, () => true).length > 0;
};
